// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"59f661c9","183":"0acd9366","197":"057b71f8","435":"cf3222e3","696":"cf792d51","749":"b1f278f9"}[chunkId] + ".chunk.js";
};